import { readonly, ref } from 'vue'

/**
 * Messages éphémères (« Dépense enregistrée »). Une file unique pour toute l'application,
 * affichée par <Toaster />. Les erreurs restent plus longtemps que les confirmations.
 */

export interface ToastMessage {
  id: number
  tone: 'success' | 'info' | 'error'
  title: string
  description?: string
}

const queue = ref<ToastMessage[]>([])
let nextId = 0

export const toasts = readonly(queue)

export function dismissToast(id: number): void {
  queue.value = queue.value.filter((toast) => toast.id !== id)
}

export function toastDuration(tone: ToastMessage['tone']): number {
  return tone === 'error' ? 7000 : 4000
}

/**
 * Filet de sécurité : sur téléphone, un toucher met le minuteur du toast en pause sans jamais
 * le relancer (pas d'événement « le doigt est parti »). Chaque message se ferme donc de lui-même
 * peu après sa durée, quoi qu'il arrive.
 */
export const TOAST_GRACE = 2000

export function showToast(message: Omit<ToastMessage, 'id'>): number {
  nextId += 1
  const toast = { ...message, id: nextId }
  // Trois messages au plus : le plus ancien laisse sa place.
  queue.value = [...queue.value.slice(-2), toast]
  setTimeout(
    () => {
      dismissToast(toast.id)
    },
    toastDuration(toast.tone) + TOAST_GRACE,
  )
  return toast.id
}
